var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "h5",
      {
        staticClass:
          "card-header d-flex justify-content-between align-items-center rank-title"
      },
      [
        _vm._v(
          " " +
            _vm._s(
              _vm.ui.formatString(_vm.T.authorRankRangeHeader, {
                lowCount: (_vm.page - 1) * _vm.length + 1,
                highCount: _vm.page * _vm.length
              })
            ) +
            " "
        )
      ]
    ),
    _c("table", { staticClass: "table mb-0" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
            _vm._v("#")
          ]),
          _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.T.contentCreator))
          ]),
          _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
            _vm._v(_vm._s(_vm.T.rankScore))
          ]),
          _c("th", { staticClass: "text-center", attrs: { scope: "col" } })
        ])
      ]),
      _c(
        "tbody",
        _vm._l(_vm.rankingData.ranking, function(author, index) {
          return _c("tr", { key: index }, [
            _c("th", { staticClass: "text-center", attrs: { scope: "row" } }, [
              _vm._v(" " + _vm._s(author.author_ranking || index) + " ")
            ]),
            _c(
              "td",
              { staticClass: "text-center" },
              [
                _c("omegaup-countryflag", {
                  attrs: { country: author.country_id }
                }),
                _c("omegaup-user-username", {
                  attrs: {
                    classname: author.classname,
                    linkify: true,
                    username: author.username
                  }
                }),
                author.name
                  ? _c("span", [
                      _c("br"),
                      _vm._v(" " + _vm._s(author.name) + " ")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(" " + _vm._s(author.author_score.toFixed(2)) + " ")
            ])
          ])
        }),
        0
      )
    ]),
    _c(
      "div",
      { staticClass: "card-footer" },
      [
        _c("omegaup-common-paginator", {
          attrs: { "pager-items": _vm.pagerItems }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }